import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import PacmanLoader from 'react-spinners/PacmanLoader';

import { setAuth } from 'redux/actions/auth';
import { setHeader } from 'redux/actions/header';
import { BASE_URL, TOKEN_STORAGE_KEY, ACCOUNTS_DASHBOARD_URL } from 'redux/actions/constants';
import UserTypes from 'enums/user-types';

const CURRENT_USER_URL = `${BASE_URL}/api/user/current-user`;

/**
 * K12NET (ve ileride benzer redirect tabanlı SSO'lar) için ortak giriş sayfası.
 *
 * Backend (core/src/routes/auth.routes.ts), K12NET login'i tamamlayıp code'u zaten JWT'ye
 * çevirdikten SONRA tarayıcıyı buraya `?token=<jwt>` ile yönlendirir. Yani burada yapılacak şey
 * Vcloud/Pusula'daki gibi partner token'ını backend'e gönderip JWT almak değil — JWT elimizde
 * zaten var, sadece bu token ile current-user'ı çekip normal bir oturum başlatmamız yeterli.
 */
const SsoSuccess = ({ setAuthState, setHeaderState }) => {
  const { search } = useLocation();
  const history = useHistory();

  useEffect(() => {
    const token = new URLSearchParams(search).get('token');

    if (!token) {
      history.replace('/signin');
      return;
    }

    // Garanti olması için local storage'a da token'ı doğrudan kaydet (SIGNIN_FEATURE'daki
    // pattern ile aynı).
    localStorage.setItem(TOKEN_STORAGE_KEY, token);

    axios
      .get(CURRENT_USER_URL, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => {
        const authPayload = data?.data;
        setAuthState({ auth: authPayload });
        setHeaderState({
          header: {
            organization: authPayload?.currentUser?.organization?.id,
            suborganization: authPayload?.currentUser?.suborganizations?.[0]?.id,
          },
        });

        const userType = authPayload?.currentUser?.userType;
        if (userType === UserTypes.other || userType === UserTypes.demoOther) {
          window.open(`${ACCOUNTS_DASHBOARD_URL}?op=${authPayload?.token}`, '_self');
        } else if (
          userType === UserTypes.student ||
          userType === UserTypes.demoStudent
        ) {
          history.replace('/student');
        } else {
          history.replace('/');
        }
      })
      .catch(() => {
        localStorage.removeItem(TOKEN_STORAGE_KEY);
        history.replace('/signin');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="loading whole-screen" style={{ zIndex: 0 }}>
      <PacmanLoader color="#67BCEC" size={50} />
    </div>
  );
};

const mapDispatchToProps = {
  setAuthState: setAuth,
  setHeaderState: setHeader,
};

export default connect(null, mapDispatchToProps)(SsoSuccess);
